import React from "react";
import Skeleton from "@mui/material/Skeleton";

const UserListItemSkeleton = () => {
  return (
    <li className="user-item loading">
      {/* Avatar */}
      <div className="user-avatar-section">
        <Skeleton variant="circular" width={40} height={40} />
      </div>

      {/* Content */}
      <div className="user-content">
        <div className="user-header">
          <Skeleton variant="text" width={120} height={20} />
        </div>

        <div className="user-footer">
          <Skeleton variant="text" width="80%" height={16} />
        </div>
      </div>
    </li>
  );
};

export default React.memo(UserListItemSkeleton);
